<template>
  <div class="slt-wrp">
    <div class="bg-mask" @click="isShowCheckIn = false" v-show="isShowCheckIn"></div>
    <div class="slt-tar" @click="onShowPanel">
      <span>{{$t('hotel.PREFIX_ADULTS')}}{{adults}}{{+adults > 1 ? $t('hotel.SUFFIX_ADULTS') : $t('hotel.SUFFIX_ADULT')}}<!-- 成人 --></span>
      <span>{{$t('hotel.PREFIX_CHILDREN')}}{{children}}{{+children > 1 ? $t('hotel.SUFFIX_CHILDREN') : $t('hotel.SUFFIX_CHILD')}}<!-- 儿童 --></span>
    </div>

    <div class="oper-wrp" v-if="isShowCheckIn">
      <div class="person-ctrl">
        <div class="clearfix ctrl-row">
          <div class="ct-left">{{$t('hotel.SUFFIX_ADULTS')}}<!-- 成人 --></div>
          <div class="ct-right">
            <bg-count v-model="adults" :max="maxAdults"></bg-count>
          </div>
        </div>
        <div class="ctrl-row">
          <div class="ct-left">{{$t('hotel.SUFFIX_CHILDREN')}}<!-- 儿童 --></div>
          <div class="ct-right">
            <bg-count v-model="children" :max="maxChildren"></bg-count>
          </div>
        </div>
      </div>

      <div class="bottom-ctrl">
        <div v-if="+children > 0" style="font-size: 0;">
          <p class="child-tt">{{$t('hotel.CHILD_AGE')}}<!-- 儿童年龄 -->：</p>
          <div>
            <template v-for="i in children">
              <age-ctrl :default-age="ages[i - 1] ? ages[i - 1] : 0" :key="i" @on-age="onGetAge(i, arguments)"></age-ctrl>
            </template>
          </div>
        </div>

        <div class="bt-row">
          <bg-button type="primary" is-blank class="cancel-btn" font-weight="bold" @click.native="isShowCheckIn = false">{{$t('hotel.CANCEL')}}<!-- 取消 --></bg-button>
          <bg-button type="primary" class="cancel-confirm" font-weight="bold" @click.native="onConfirm">{{$t('hotel.OK')}}<!-- 确定 --></bg-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BgButton from '../BgButton/BgButton';
  import BgCount from '../BgCount/BgCount';
  import AgeCtrl from './age-ctrl';
  import {mapGetters} from 'vuex';

  export default {
    name: 'check-in-number',
    components: {
      BgButton,
      BgCount,
      AgeCtrl,
    },
    props: {
      rooms: {
        type: Number | String,
        default: 1,
      },
    },
    data(){
      return {
        isShowCheckIn: false,
        maxAdults: 10,
        maxChildren: 3,
        adults: 1,
        children: 0,
        ages: [],
      };
    },
    computed: {
      ...mapGetters({
        getAdults: 'getAdults',
        getChildren: 'getChildren',
        getAges: 'getAges',
      }),
    },
    watch: {
      rooms(cur){
        this.maxAdults = cur * 10;
        this.maxChildren = cur * 3;

        if(this.children > this.maxChildren){
          this.children = this.maxChildren;
          this.ages = this.ages.splice(0, this.maxChildren);
        }

        if(this.adults > this.maxAdults){
          this.adults = this.maxAdults;
        }
      },

      children(cur){
        if(cur > this.ages.length){
          this.ages.push(0);
        }else{
          this.ages.pop();
        }
      },
    },
    mounted(){
      this.maxAdults = this.rooms * 10;
      this.maxChildren = this.rooms * 3;
      this.children = this.getChildren;
      this.adults = this.getAdults;

      setTimeout(() => {
        this.ages = this.getAges.split(',');
      }, 100);
    },
    methods: {
      onShowPanel(){
        this.isShowCheckIn = !this.isShowCheckIn;
      },

      onConfirm(){
        const result = {
          adults: this.adults,
          children: this.children,
          ages: this.ages,
        };

        this.isShowCheckIn = false;
        this.$emit('on-condition', result);
      },

      onGetAge(idx, args){
        this.$set(this.ages, idx - 1, args[0].toString());
      },
    },
  }
</script>

<style lang="scss" scoped>
  .slt-wrp{
    min-width: 90px;
    position: relative;

    .slt-tar{
      position: relative;
      height: 44px;
      line-height: 44px;
      padding-left: 10px;
      background: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid #D6D7DC;
      cursor: pointer;

      span{
        color: #666;
      }
      &:before{
        position: absolute;
        content: "";
        display: block;
        width: 30px;
        height: 100%;
        top: 0;
        right: 0;
        background: {
          repeat: no-repeat;
          size: 12px 9px;
          image: url("/static/images/btn_up_table.png");
          position: center;
        };
      }
    }
    .oper-wrp{
      position: absolute;
      width: 290px;
      left: 0;
      top: 44px;
      padding: 14px;
      z-index: 5;
      background: #fff;
      border: 1px solid #E9E9E8;
      border-radius: 0 0 4px 4px;
      box-sizing: border-box;

      .person-ctrl{
        border-bottom: 1px dashed #C8C7CC;
      }
      .ctrl-row{
        height: 24px;
        line-height: 24px;
        margin-bottom: 20px;

        .ct-left{
          float: left;
          color: #666;
        }
        .ct-right{
          float: right;
          text-align: right;
        }
      }

      .bottom-ctrl{
        .child-tt{
          margin-top: 14px;
          margin-bottom: 10px;
        }
        .bt-row{
          margin-top: 20px;
          font-size: 0;
        }
        .cancel-btn{
          margin-right: 20px;
        }
      }
    }
  }

  .bg-mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/CheckInNumber/CheckInNumber.vue